import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroMdfe from '../../actions/mdfe/adicionarFiltroMdfe'
import removerFiltroMdfe from '../../actions/mdfe/removerFiltroMdfe'
import listarFiltrosMdfe from '../../actions/mdfe/listarFiltrosMdfe'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import FiltroBuscaMdfe from './FiltroBuscaMdfe'
import FiltroChaveValor from '../comum/FiltroChaveValor';
import {
  FILTRO_DATA_EMISSAO_MDFE,
  FILTRO_ID_MDFE,
  FILTRO_PLACA_MDFE,
  FILTRO_STATUS_MDFE,
} from '../../util/filtros'
import { statusTransmissaoMdfe } from '../../util/constantsUtil'

export class FiltroMdfe extends Component {
  componentDidMount() {
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.props.listarFiltrosMdfe(this.props.empresaSelecionada.id)
    }
  }

  componentDidUpdate(prevProps) {
    if (alterouEmpresa(this.props, prevProps)) {
      this.props.listarFiltrosMdfe(this.props.empresaSelecionada.id)
    }
  }

  adicionarFiltro(filtro) {
    this.props.adicionarFiltroMdfe(filtro)
  }

  removerFiltro(filtro) {
    this.props.removerFiltroMdfe(filtro)
  }

  render() {
    return (
      <React.Fragment>
        <div className="conteudo">
          <FiltroBuscaMdfe
            filtro={FILTRO_DATA_EMISSAO_MDFE}
            opcoes={[new Date().getFullYear()]}
            isFiltroData={true}
          />
          <FiltroBuscaMdfe
            filtro={FILTRO_ID_MDFE}
            isNumero={true}
          />
          <FiltroBuscaMdfe
            filtro={FILTRO_PLACA_MDFE}
            opcoes={[]}
            isNome={true}
          />
          <FiltroChaveValor
            filtro={FILTRO_STATUS_MDFE}
            opcoes={statusTransmissaoMdfe}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
        </div>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = state => ({
  filtrosAdicionados: state.filtrosAdicionadosMdfe,
  empresaSelecionada: state.empresaSelecionada,
})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroMdfe,
    removerFiltroMdfe,
    listarFiltrosMdfe
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroMdfe)
